// AUTO-GENERATED from `pine_large.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 44166,
    "type": "evergreen",
    "bark": {
      "type": "Bark003",
      "tint": 16777215,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 1
      }
    },
    "branch": {
      "levels": 1,
      "angle": {
        "1": 129.1304347826087,
        "2": 16,
        "3": 60
      },
      "children": {
        "0": 100,
        "1": 3,
        "2": 0
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.009000000000000001
      },
      "gnarliness": {
        "0": 0.05,
        "1": 0.08,
        "2": 0,
        "3": 0
      },
      "length": {
        "0": 65.25217391304348,
        "1": 34.84782608695652,
        "2": 27.246739130434783,
        "3": 1
      },
      "radius": {
        "0": 1.271739130434783,
        "1": 0.366304347826087,
        "2": 0.7,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 10,
        "2": 8,
        "3": 6
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.29347826086956524,
        "2": 0.14,
        "3": 0.3
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0,
        "1": 0,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "pine",
      "billboard": "double",
      "angle": 17,
      "count": 18,
      "start": 0.07608695652173914,
      "size": 2.608695652173913,
      "sizeVariance": 0.201,
      "tint": 16777215,
      "alphaTest": 0.3
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
